import { render, staticRenderFns } from "./_tabSpecificMentions.vue?vue&type=template&id=2e999c78&"
import script from "./_tabSpecificMentions.vue?vue&type=script&lang=js&"
export * from "./_tabSpecificMentions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports